// demoScope — what the demonstrator shows, as plain typed constants.
//
// The demonstrator (docs/requirements/vision-and-scope.md LI-1..LI-3)
// HIDES capabilities outside its scope; it never deletes them. Every
// hidden capability is gated on exactly one constant below, read by the
// agent tools, the system prompt, the addSource workflow and the client.
// To bring a capability back, widen the constant (and see
// docs/requirements/hidden-capabilities.md for the tests that pin it).
//
// Compile-time constants, not runtime flags: no env var, no setting.
// Pure: no I/O. Exposed to the client as `@bilda/app/demoScope`.
export { acceptedIngestExtensions, acceptedIngestKindsText, acceptsSourceMediaType, ingestKinds, isReachableWorkspaceRole, isVisibleExportFormat, reachableWorkspaceRoles, visibleExportFormats, };
import * as D from "@bilda/core";
// === Exports (FR-10.4, LI-1) ===
//
// Torus and Canvas (Common Cartridge) are offered. The other codecs
// (F_html, F_pdf, F_markdown, F_text) stay registered and tested; the
// export dialog, the agent's format catalogue and
// `create_package_from_material` filter on this list.
const visibleExportFormats = [
    D.Format.torus,
    D.Format.canvas,
];
const isVisibleExportFormat = (formatId) => visibleExportFormats.some((f) => D.Format.Id.from(f.id) === formatId);
const ingestKinds = [
    {
        name: "plain text",
        extensions: [".txt", ".md"],
        mediaTypes: ["text/plain", "text/markdown", "text/x-markdown"],
    },
    {
        name: "Word (DOCX)",
        extensions: [".docx"],
        mediaTypes: [
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ],
    },
    {
        name: "PowerPoint (PPTX)",
        extensions: [".pptx"],
        mediaTypes: [
            "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        ],
    },
    { name: "PDF", extensions: [".pdf"], mediaTypes: ["application/pdf"] },
];
const acceptedIngestExtensions = ingestKinds.flatMap((k) => k.extensions);
// Media-type parameters (`; charset=utf-8`) do not change the kind.
const acceptsSourceMediaType = (mediaType) => {
    const bare = mediaType.split(";")[0]?.trim().toLowerCase() ?? "";
    return ingestKinds.some((k) => k.mediaTypes.includes(bare));
};
// Agent-facing list of the accepted kinds (system prompt + tool errors).
const acceptedIngestKindsText = ingestKinds
    .map((k) => k.name)
    .join(", ");
const reachableWorkspaceRoles = ["owner"];
const isReachableWorkspaceRole = (role) => reachableWorkspaceRoles.includes(role);
//# sourceMappingURL=demoScope.js.map